<template>
  <transition
    mode="out-in"
    name="fade"
    @beforeEnter="handleBeforeEnter"
    @afterEnter="handleAfterEnter"
    @afterLeave="handleAfterLeave"
  >
    <component
      :is="tag"
      ref="panel"
      v-show="localActiveState"
      role="tabpanel"
      :id="computedID"
      :aria-hidden="localActiveState ? 'false' : 'true'"
      :aria-expanded="localActiveState ? 'true' : 'false'"
      :aria-labelledby="controlledBy || null"
      :class="[
        'tab-pane',
        $parent && $parent.card && !noBody ? 'card-body' : '',
        show ? 'show' : '',
        disabled ? 'disabled' : '',
        localActiveState ? 'active' : '',
      ]"
    >
      <slot />
    </component>
  </transition>
</template>

<script>
const uuidv1 = require("uuid/v1");

const DEFAULT_ON_NEXT_PREVIOUS = () => {
  return { result: true, errorMsg: "" };
};

export default {
  name: "odd-wizard-tab",
  data() {
    return {
      localActiveState: this.active && !this.disabled,
      show: false,
    };
  },
  props: {
    /**
     * The element ID.
     */
    id: {
      type: String,
      default: null,
    },
    /**
     * The active state.
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * The element tag.
     */
    tag: {
      type: String,
      default: "div",
    },
    /**
     * The button ID.
     */
    buttonId: {
      type: String,
      default: "",
    },
    /**
     * The title.
     */
    title: {
      type: String,
      default: "",
    },
    /**
     * The disabled state.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Whether the card should display the body, or not.
     */
    noBody: {
      type: Boolean,
      default: false,
    },
    /**
     * The link class.
     */
    titleLinkClass: {
      type: String,
      default: null,
    },
    /**
     * The item class.
     */
    titleItemClass: {
      type: String,
      default: null,
    },
    onNext: {
      type: Function,
      default: DEFAULT_ON_NEXT_PREVIOUS,
    },
    onPrevious: {
      type: Function,
      default: DEFAULT_ON_NEXT_PREVIOUS,
    },
  },
  computed: {
    computedID() {
      return this.id || `wiz-tab-${uuidv1()}`;
    },
    controlledBy() {
      return this.buttonId || `wiz-tab-button-${uuidv1()}`;
    },
    computedFade() {
      return this.$parent.fade;
    },
    _isWizardTab() {
      return true;
    },
  },
  methods: {
    handleBeforeEnter() {
      this.show = false;
    },
    handleAfterEnter() {
      this.show = true;
    },
    handleAfterLeave() {
      this.show = false;
    },
    next() {
      return this.onNext();
    },
    previous() {
      return this.onPrevious();
    },
  },
  mounted() {
    this.show = this.localActiveState;
  },
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 0.25s ease-in-out;
}

.fade-leave-active {
  transition: opacity 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
